import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || '/api/v1'

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
})

// Response interceptor — surface clean error messages
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const msg =
      err.response?.data?.message ||
      err.response?.data?.error ||
      err.message ||
      'خطأ غير معروف'
    return Promise.reject(new Error(msg))
  }
)

export default api
